import { useMemo } from "react";
import { C } from "../lib/theme";
import { Icon } from "./Icon";
import { gradientForId } from "../lib/gradients";
import { fmtK } from "../lib/money";
import { resolveImage } from "../lib/images";
import { useWishlist } from "../store/wishlistStore";

export function ProductCard({ product, onOpen, onWish }) {
  const p = product;
  const [g1, g2] = gradientForId(p.id);
  const img = useMemo(() => resolveImage(p.images, "med"), [p.images]);
  const sellerName = p.sellers?.store_name || "Kapio seller";
  const hasDiscount = p.compare_price && p.compare_price > p.price;
  const discountPct = hasDiscount ? Math.round((1 - p.price / p.compare_price) * 100) : 0;
  const wished = useWishlist((s) => !!s.map[p.id]);
  const toggleWish = useWishlist((s) => s.toggle);

  return (
    <div style={{ cursor: "pointer" }} onClick={() => onOpen?.(p)}>
      <div
        style={{
          aspectRatio: "1",
          borderRadius: 16,
          background: img ? `url(${img}) center/cover` : `linear-gradient(135deg, ${g1}, ${g2})`,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!img && (
          <span style={{ fontSize: 64, filter: "drop-shadow(0 6px 18px rgba(0,0,0,.2))", color: C.white, opacity: 0.8 }}>
            {p.category?.icon || "🛍️"}
          </span>
        )}
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleWish(p.id);
            onWish?.(p);
          }}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            width: 32,
            height: 32,
            border: "none",
            borderRadius: 10,
            background: wished ? C.red : "rgba(255,255,255,0.9)",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon name="heart" size={14} color={wished ? C.white : C.charcoal} />
        </button>
        {p.sellers?.address && (
          <div
            style={{
              position: "absolute",
              bottom: 10,
              left: 10,
              padding: "3px 8px",
              borderRadius: 6,
              background: "rgba(255,255,255,0.9)",
              fontSize: 10,
              fontWeight: 700,
              color: C.hunter,
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              maxWidth: 140,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <Icon name="map-pin" size={9} color={C.hunter} />
            {p.sellers.address}
          </div>
        )}
        {hasDiscount && (
          <div
            style={{
              position: "absolute",
              top: 10,
              left: 10,
              padding: "3px 7px",
              borderRadius: 6,
              background: C.red,
              color: C.white,
              fontSize: 9.5,
              fontWeight: 800,
            }}
          >
            −{discountPct}%
          </div>
        )}
      </div>
      <div style={{ padding: "10px 4px" }}>
        <div
          style={{
            fontSize: 13,
            fontWeight: 700,
            marginBottom: 3,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {p.title}
        </div>
        <div style={{ fontSize: 11, color: C.muted }}>{sellerName}</div>
        <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginTop: 5 }}>
          <span style={{ fontSize: 15, fontWeight: 900, color: C.hunter, letterSpacing: "-0.3px" }}>
            {fmtK(p.price)}
          </span>
          {hasDiscount && (
            <span style={{ fontSize: 11, color: C.muted, textDecoration: "line-through" }}>
              {fmtK(p.compare_price)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
